import { render, staticRenderFns } from "./FundWithdraw.vue?vue&type=template&id=2c5a366c&scoped=true&"
import script from "./FundWithdraw.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FundWithdraw.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a366c",
  null
  
)

export default component.exports